import React from 'react';
import FileInput from '@ui/uploads/file-input';
import useUploader from './use-uploader';
import styles from './uploader.module.css';
import { allowedFileTypes, UPLOAD_TYPES } from '@/micros/homepage/content/utils/content-utils';

const Uploader = () => {
  const { jobsInProgress, inputElements, handleFileChange } = useUploader();

  return (
    <div className={styles['uploader-container']}>
      {jobsInProgress.map((job) => {
        return (
          <React.Fragment key={job.uuid}>
            {job.filename && (
              <div className={styles['uploading-job']}>
                {job.done ? (
                  <span>
                    Uploading {job.filename} <span className={styles['job-progress']}>Done!</span>
                  </span>
                ) : (
                  <span>
                    Uploading {job.filename} <span className={styles['job-progress']}>{job.progress}%</span>
                  </span>
                )}
              </div>
            )}

            <FileInput
              type="file"
              accept={allowedFileTypes[UPLOAD_TYPES.VIDEO]}
              style={{ display: 'none' }}
              onChange={handleFileChange(job)}
              ref={(ref) => {
                inputElements.current[job.uuid] = ref;
              }}
            />
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Uploader;
